import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IGeography, IGeographyDropDown, ICountry } from '@shared/interfaces';
import { GeographyService } from '@shared/services/geography.service';

@Component({
    selector: 'app-multi-select-dropdown',
    templateUrl: './multi-select-dropdown.component.html',
    providers: [GeographyService],
    styleUrls: ['./multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent implements OnInit {

    countryList: IGeographyDropDown[] = [];
    stateList: IGeographyDropDown[] = [];
    countyList: IGeographyDropDown[] = [];
    dropdownCountrySettings = {};
    dropdownStateSettings = {};
    dropdownCountySettings = {};

    @Input() selectedCountryList: IGeographyDropDown[] = [];
    @Input() selectedStateList: IGeographyDropDown[] = [];
    @Input() selectedCountyList: IGeographyDropDown[] = [];
    @Input() maxHeight: number = 250;
    @Output() childEventCountry = new EventEmitter();
    @Output() childEventState = new EventEmitter();
    @Output() childEventCounty = new EventEmitter();

    constructor(private geographyService: GeographyService) { }

    ngOnInit() {
        this.setCountryOptions();
        this.dropdownCountrySettings = {
            text: 'Select Countries',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            clearSearchFilter: true,
            classes: 'myclass custom-class',
            badgeShowLimit: 2,
            lazyLoading: true,
            maxHeight: this.maxHeight
        };
        this.dropdownStateSettings = {
            text: 'Select States',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            clearSearchFilter: true,
            classes: 'myclass custom-class',
            badgeShowLimit: 2,
            lazyLoading: true,
            maxHeight: this.maxHeight,
        };
        this.dropdownCountySettings = {
            text: 'Select Counties',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            clearSearchFilter: true,
            classes: 'myclass custom-class',
            badgeShowLimit: 2,
            lazyLoading: true,
            maxHeight: this.maxHeight
        };
    }

    setCountryOptions(): void {
        this.geographyService.PermitCountries.getData().subscribe((countries: ICountry[]) => {
            this.countryList = countries.map(p => <IGeographyDropDown>{ id: p.AoiId, itemName: p.Name });
        });
        this.setStateOptions();
    }
    setStateOptions(): void {
        this.geographyService.GetGeographyByParents(this.selectedCountryList.map(p => p.id)).subscribe((members: IGeography[]) => {
            this.stateList = members.map(p => <IGeographyDropDown>{ id: p.MemberAoiId, itemName: p.MemberAoiName });
        });
    }
    setCountyOptions(): void {
        this.geographyService.GetGeographyByParents(this.selectedStateList.map(p => p.id)).subscribe((members: IGeography[]) => {
            this.countyList = members.map(p => <IGeographyDropDown>{ id: p.MemberAoiId, itemName: p.MemberAoiName });
        });
    }

    onCountryItemSelect(item: any) {
        this.setStateOptions();
        this.childEventCountry.emit(this.selectedCountryList);
    }
    OnCountryItemDeSelect(item: any) {
        this.setStateOptions();
        this.childEventCountry.emit(this.selectedCountryList);
    }
    onCountrySelectAll(items: any) {
        this.setStateOptions();
        this.childEventCountry.emit(this.selectedCountryList);
    }
    onCountryDeSelectAll(items: any) {
        this.setStateOptions();
        this.childEventCountry.emit(this.selectedCountryList);
    }
    onCountryFilterSelectAll(items: any) {
        this.setStateOptions();
        this.childEventCountry.emit(this.selectedCountryList);
    }
    onCountryFilterDeSelectAll(items: any) {
        this.setStateOptions();
        this.childEventCountry.emit(this.selectedCountryList);
    }

    onStateItemSelect(item: any) {
        this.setCountyOptions();
        this.childEventState.emit(this.selectedStateList);
    }
    OnStateItemDeSelect(item: any) {
        this.setCountyOptions();
        this.childEventState.emit(this.selectedStateList);
    }
    onStateSelectAll(items: any) {
        this.setCountyOptions();
        this.childEventState.emit(this.selectedStateList);
    }
    onStateDeSelectAll(items: any) {
        this.setCountyOptions();
        this.childEventState.emit(this.selectedStateList);
    }
    onStateFilterSelectAll (items: any) {
        this.setCountyOptions();
        this.childEventState.emit(this.selectedStateList);
    }
    onStateFilterDeSelectAll(items: any) {
        this.setCountyOptions();
        this.childEventState.emit(this.selectedStateList);
    }

    //onCountyItemSelect(item: any) {
    //}
    //OnCountyItemDeSelect(item: any) {
    //}
    //onCountySelectAll(items: any) {
    //    this.childEventCounty.emit(items);
    //}
    //onCountyDeSelectAll(items: any) {
    //    this.childEventCounty.emit(items);
    //}
}
